import { render, staticRenderFns } from "./newAfterDetail.vue?vue&type=template&id=41fef7a4&"
import script from "./newAfterDetail.vue?vue&type=script&lang=js&"
export * from "./newAfterDetail.vue?vue&type=script&lang=js&"
import style0 from "./newAfterDetail.vue?vue&type=style&index=0&id=41fef7a4&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41fef7a4')) {
      api.createRecord('41fef7a4', component.options)
    } else {
      api.reload('41fef7a4', component.options)
    }
    module.hot.accept("./newAfterDetail.vue?vue&type=template&id=41fef7a4&", function () {
      api.rerender('41fef7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/newAfterDetail.vue"
export default component.exports